import React, { useState } from "react";
import { useSite } from "../../context/site";
import SwitchControl from "../../components/site/SwitchControl";
import { Eyebrow, Cta } from "../../components/site/kit";
import { ArrowField } from "../../components/site/motion";
import { track } from "../../lib/analytics";
import { useHomeCopy } from "../../lib/siteContent";
import { RichCopy } from "../../components/site/RichCopy";

export const Hero = ({ onReset }) => {
  const { openTalk } = useSite();
  const c = useHomeCopy();
  const [active, setActive] = useState(true);
  // Flipping the switch OFF returns to the splash (the "growth off" state);
  // flipping ON (only reachable if already off) re-aligns the field.
  const toggle = () => {
    if (active) { setActive(false); track("home_hero_switched_off"); setTimeout(() => onReset(), 260); }
    else { setActive(true); }
  };
  return (
    <section data-testid="home-hero" className="relative min-h-screen overflow-hidden bg-[#161A15]">
      {/* the switch made visual: scattered effort (off) resolving into one green trajectory (on) */}
      <div aria-hidden className="pointer-events-none absolute inset-y-0 right-0 hidden w-[46%] lg:block">
        <ArrowField active={active} className="h-full w-full" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(90deg,#161A15 0%, rgba(22,26,21,0.55) 24%, rgba(22,26,21,0) 60%)" }} />
      </div>

      <div className="relative z-10 mx-auto grid min-h-screen w-full max-w-[1360px] items-center px-6 pb-24 pt-32 md:px-12 lg:px-16">
        <div className="max-w-2xl">
          <Eyebrow dark>{active ? c.heroEyebrow : "State, Working apart"}</Eyebrow>
          <h1 className="font-display mt-8 text-5xl leading-[0.95] tracking-tight text-white sm:text-6xl md:text-7xl lg:text-8xl">
            <RichCopy text={c.heroHeading} />
          </h1>

          <p className="font-body mt-8 max-w-md text-lg font-normal leading-relaxed text-white/80">
            {c.heroSubhead}
          </p>

          <div className="mt-12 flex flex-col gap-4 sm:flex-row sm:flex-wrap sm:gap-5">
            <Cta primary onClick={() => openTalk()} testId="home-hero-cta" className="w-full justify-between sm:w-auto sm:justify-center">{c.heroCta1}</Cta>
            <Cta dark to="/find-your-switch" testId="home-hero-cta-2" className="w-full justify-between sm:w-auto sm:justify-center">{c.heroCta2}</Cta>
          </div>

          {/* the switch, kept as a deliberate hero interaction (de-SaaS: no "system / on-off" framing) */}
          <div className="mt-14 flex w-full max-w-md items-center justify-between border-t border-white/15 pt-6">
            <span className="font-body text-xs font-semibold uppercase tracking-[0.2em] text-white/50">Flip the switch</span>
            <div data-testid="home-hero-switch" className="flex items-center gap-3">
              <SwitchControl active={active} onToggle={toggle} size="md" tone="dark" testId="home-hero-toggle" ariaLabel={active ? "Switch growth off" : "Switch growth on"} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

